import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRust, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Rust",
    "Python",
    "Typescript",
    "PostgreSQL",
    "Bash",
    "Postman",
    "APIDog",
    "Git",
];

const labelsSecond = [
    "Airflow",
    "Spring Batch",
    "Docker",
    "AWS",
    "Azure",
    "Linux",
];

const labelsThird = [
    "Python",
    "Julia",
    "Jupyter Notebooks",
    "Streamlit",
    "Pandas",
    "Numpy",
    "Matplotlib",
    "Plotly",
    "Scikit-learn",
    "Music21"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faRust} size="3x"/>
                    <h3>Backend Blockchain Development</h3>
                    <p>I helped build the Vulcan Forge API - a SaaS product facilitating the creation, transfer, and regulation of bonds, stocks, loans, and other financial assets captured as digital entities and transferred across the Solana blockchain environment. From an empty repo to integration in platforms at the Solana Foundation, I was responsible for taking many API endpoints from design to prodcution.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>Cloud Infra & Automation</h3>
                    <p>As the primary maintainer of automations at a startup, I've had my hands at building and maintaing automation pipelines to fetch data, generate reports, and manage cloud compute resources.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>Data Science & Analytics</h3>
                    <p>With a degree in applied mathematics focused on statistical analysis, I've spent my undergraduate career designing and implementing research projects involving not just data analysis but also effectively communicating my findings through presentations and lecture recitals.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;